export default {

	Auth: () => import('@/layouts/Auth/index.svelte'),
	Admin: () => import('@/layouts/Admin/index.svelte'),

};
